import { NgModule } from "@angular/core";
import { RouterModule, Routes, PreloadAllModules } from "@angular/router";
import { LoginComponent } from "./pages/authentication/login/login.component";
import { ContentLayoutComponent } from "./shared/components/layout/content-layout/content-layout.component";
import { FullLayoutComponent } from "./shared/components/layout/full-layout/full-layout.component";
import { content } from "./shared/routes/content-routes";
import { full } from "./shared/routes/full.routes";
import { AdminGuard } from "./shared/guard/admin.guard";
import { EmailVerifiedGuard } from "./shared/guard/email-verified.guard";
import { RegisterComponent } from "./pages/authentication/register/register.component";
import { EmailVerificationComponent } from "./pages/authentication/verification/email-verification/email-verification.component";
import { ForgetPwdComponent } from "./pages/authentication/forget-pwd/forget-pwd.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "learning/learninglist",
    pathMatch: "full",
  },
  {
    path: "authentication/login",
    component: LoginComponent,
  },
  {
    path: "authentication/register",
    component: RegisterComponent,
  },
  {
    path: "authentication/verificate",
    component: EmailVerificationComponent,
  },
  {
    path: "authentication/forgetpassword",
    component: ForgetPwdComponent,
  },
  {
    path: "",
    component: ContentLayoutComponent,
    canActivate: [EmailVerifiedGuard, AdminGuard],
    children: content,
  },
  {
    path: "",
    component: FullLayoutComponent,
    canActivate: [EmailVerifiedGuard, AdminGuard],
    children: full,
  },
  {
    path: "**",
    redirectTo: "",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      anchorScrolling: "enabled",
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
